import type { DefinitionsCatalogBody, VisualizationTypesCatalogBody } from '../models/catalog.types'

// Body guards for the two catalogs module 08 consumes. `shared/catalog` owns transport,
// freshness and storage; validating the payload stays with the module that knows its shape —
// an unparseable body must be a cache miss, never a poisoned store.

function record(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export function isValidDefinitionsCatalog(body: unknown): body is DefinitionsCatalogBody {
  if (!record(body)) return false
  return [body.metrics, body.dimensions].every(
    (group) => record(group) && Array.isArray(group.data) && typeof group.total_count === 'number',
  )
}

export function isValidVisualizationTypesCatalog(
  body: unknown,
): body is VisualizationTypesCatalogBody {
  return (
    record(body) &&
    Array.isArray(body.results) &&
    body.results.every(record) &&
    typeof body.total === 'number'
  )
}
